import { render, staticRenderFns } from "./TerminalDisplayDetails.vue?vue&type=template&id=228918db"
import script from "./TerminalDisplayDetails.vue?vue&type=script&lang=js"
export * from "./TerminalDisplayDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports